<template>
  <div class="col-12">
    <v-form ref="profileForm">
      <v-row>
        <v-col
          cols="4"
          class="ma-0"
        >
          <naj-input
            :type-id="formFieldType.text"
            :value.sync="complaintObj.executionVerificationObj.caseNo"
            :label="local.complaints.complainantType.requestNo"
            :validates="`required`"
            :disabled="disabledMode"
          ></naj-input>
        </v-col>
        <v-col cols="8">
          <v-row>
            <v-col class="col-6">
              <naj-input
                :type-id="formFieldType.selectbox"
                :value.sync="complaintObj.executionVerificationObj.applyTypeId"
                :label="local.complaints.complaintDetails.caseInfo.relation"
                :items="filterApplyTypes"
                item-value="id"
                item-text="type"
                :validates="`required`"
                :disabled="disabledMode"
              ></naj-input>
            </v-col>
            <v-col class="col-6">
              <naj-input
                v-if="complaintObj.executionVerificationObj.applyTypeId && complaintObj.executionVerificationObj.applyTypeId != 1"
                :type-id="formFieldType.text"
                :value.sync="complaintObj.executionVerificationObj.applyTypeCode"
                :label="getApplyCodeLabel"
                :validates="`required`"
                :disabled="disabledMode"
              ></naj-input>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="col-12 text-left">
          <naj-button
            v-if="!disabledMode"
            :loading="loading"
            @click="submit"
          >
            {{ local.common.check }}
          </naj-button>
        </v-col>
      </v-row>
      <v-row
        v-if="complaintObj.verifiedCase || complaintObj.complaintForm.formModel.viewMode"
        class="ma-0"
      >
        <v-col>
          <case-card
            :headers="headers"
            :item="complaintObj.executionRequestInfo"
            :status="status"
          ></case-card>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers('LookupsModule');
const { mapActions: mapComplaintsActions } = createNamespacedHelpers('ComplaintsModule');
import CaseCard from './caseCard.vue';
import { toHijriDate } from '@/helpers/utils';

export default {
  name: 'ExecutionVerification',
  components: { CaseCard },
  props: {
    complaintObj: {
      type: Object,
      default: () => ({ executionVerificationObj: {} }),
    },
  },
  data() {
    return {
      status: {},
      loading: false,
      headers: [
        {
          name: this.local.complaints.executionRequestInfo.requestNo,
          value: 'code',
        },
        {
          name: this.local.complaints.executionRequestInfo.type,
          value: 'requestTypeName',
        },
        {
          name: this.local.complaints.executionRequestInfo.requestStatus,
          value: 'requestStatusName',
        },
        {
          name: this.local.complaints.executionRequestInfo.creationDate,
          value: 'createdDate',
          formatter: toHijriDate,
        },
        {
          name: this.local.complaints.executionRequestInfo.documentType,
          value: 'documentTypeName',
        },
        {
          name: this.local.complaints.executionRequestInfo.documentTypeGroup,
          value: 'documentTypeGroupName',
        },
        {
          name: this.local.complaints.executionRequestInfo.court,
          value: 'courtName',
        },
        {
          name: this.local.complaints.executionRequestInfo.circle,
          value: 'cityName',
        },
        {
          name: this.local.complaints.executionRequestInfo.plaintiff,
          value: 'plaintiff',
        },
        {
          name: this.local.complaints.executionRequestInfo.defendant,
          value: 'defendant',
        },
      ],
    };
  },
  computed: {
    ...mapLUTState(['applyTypes']),
    getApplyCodeLabel() {
      if (this.complaintObj.executionVerificationObj.applyTypeId == 2) {
        return this.local.complaints.complainantType.attorneyCode;
      } else if (this.complaintObj.executionVerificationObj.applyTypeId == 3) {
        return this.local.complaints.complainantType.deedNo;
      } else if (this.complaintObj.executionVerificationObj.applyTypeId == 7 || this.complaintObj.executionVerificationObj.applyTypeId == 4) {
        return this.local.complaints.complainantType.unifiedNo;
      } else {
        return this.local.complaints.complainantType.generalCode;
      }
    },
    filterApplyTypes() {
      return (this.applyTypes || []).filter(a => a.isActive == true);
    },
    disabledMode() {
      return this.complaintObj.verifiedCase || this.complaintObj.complaintForm.formModel.viewMode;
    },
  },
  watch: {},
  created() {
  },
  mounted() {
    this.getApplyTypes();
  },
  methods: {
    ...mapLUTActions(['getApplyTypes']),
    ...mapComplaintsActions(['getExecutionCaseDetails']),
    submit() {
      if (this.$refs.profileForm)
        this.$refs.profileForm.$validator.validateAll()
          .then((valid) => {
            if (valid) {
              this.loading = true;
              this.getExecutionCaseDetails(this.complaintObj.executionVerificationObj)
                .then((data) => {
                  this.complaintObj.executionRequestInfo = data.data;
                  if (data.data && data.data.requestParties) {
                    this.complaintObj.executionRequestInfo.plaintiff = (data.data.requestParties.filter(a => a.partyCategoryId == 1) || []).map(u => u.partyName)
                      .join(' - ');
                    this.complaintObj.executionRequestInfo.defendant = (data.data.requestParties.filter(a => a.partyCategoryId == 2) || []).map(u => u.partyName)
                      .join(' - ');
                  }
                  this.$set(this.complaintObj, 'verifiedCase', true);
                })
                .finally(() => { this.loading = false; });
            }
          });
      // this.status = {
      //   name: 'جاري الاستعلام من الجهة',
      //   color: '#b69a70',
      // };
    },
  },
};
</script>
<style lang="scss" scoped>
.tab-header {
  height: 60px;
}
::v-deep .v-slide-group__wrapper {
  overflow: visible !important;
  contain: initial;
  display: unset !important;
}
::v-deep {
  .v-slide-group__content {
    display: block;
  }
  .v-tabs {
    box-shadow: 0 0.75rem 6rem rgba(56, 65, 74, 0.03);
    margin-bottom: 1.5rem;
    border-radius: 0.25rem;
    display: flex;
    flex-direction: column;
    .v-tabs-bar {
      flex: 1 1 auto;
      padding-block: 1.5rem;
    }
    .tabs-nav-container {
      margin-right: 0;
      margin-left: 0;
      > div {
        display: flex;
        flex-wrap: wrap;
        padding-inline: 0;
      }
      .tab-header {
        height: auto;
        flex-basis: 0;
        flex-grow: 1;
        text-align: center;
        width: auto;
        font-weight: 500;
        padding: 0.75rem 1rem;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
          border-color 0.15s ease-in-out;
        background-color: #f7f7f7;
        border: 2px solid #fff;
        color: #b69a70;
        .v-icon {
          color: #b69a70;
          margin-inline-end: 6px;
          font-size: 1.25em;
        }
        &.v-tab--active {
          color: #fff;
          background-color: #203f39;
          .v-icon {
            color: #fff;
          }
        }
      }
    }

    .v-progress-linear--striped .v-progress-linear__determinate {
      transition: width 0.6s ease;
      background-image: linear-gradient(
        -45deg,
        rgba(255, 255, 255, 0.15) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.15) 50%,
        rgba(255, 255, 255, 0.15) 75%,
        transparent 75%,
        transparent
      );
      background-size: 0.75rem 0.75rem;
      animation: 1s linear infinite progress-bar-stripes;
    }
    .v-tabs-slider-wrapper {
      display: none;
    }
  }
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 0.75rem;
  }
}
</style>
